// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"118":"b7e27b0add176b1f","229":"f4aaf7a541f0ea0d","292":"4ccff91ec0d091c2","337":"ec804229351a05f1","564":"1995464697c24b87"}[chunkId] + ".js";
};